import { z } from "zod";

/**
 * Keys for one-time, per-user UI support flows (coachmarks, guided tooltips, walkthroughs). Each
 * flow shows once per user; a `user_ui_flow` marker records that the user has seen it. Add a new
 * value here for every new flow so the key is a single source of truth across API and web.
 */
export enum UiFlowKey {
	/** The "select leads → Campaign → Add to campaign" coachmark on the unassigned table. */
	ASSIGN_LEADS_COACHMARK = "ASSIGN_LEADS_COACHMARK",
	/** The dashboard card promoting the Chrome/Edge browser extension (PREC-3815). */
	EXTENSION_PROMO_DASHBOARD = "EXTENSION_PROMO_DASHBOARD",
	/** The "Setting up outreach" explainer on the list wizard's Outreach step (PREC-3879). */
	OUTREACH_EXPLAINER = "OUTREACH_EXPLAINER",
}

export const uiFlowKeySchema = z.nativeEnum(UiFlowKey);
